export default __webpack_public_path__ + "media/images/icons/credit-card-check-33e5f814d3294a99682068e741d24944.svg";